(() => {
  'use strict';
  // Keep bookmarked homepage project anchors useful after moving their sections.
  const home = document.querySelector('[data-home-destinations]');
  if (!home) return;
  const followLegacyAnchor = () => {
    const target = { '#projects': home.dataset.galleryUrl, '#record': home.dataset.recordUrl }[location.hash];
    if (!target) return;
    const url = new URL(target, location.href);
    url.search = location.search;
    location.replace(url.href);
  };
  followLegacyAnchor();
  window.addEventListener('hashchange', followLegacyAnchor);
})();
